import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Register Quill SmartLinks module globally
import './app/core/config/quill-smart-links.config';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
